import { AfterViewInit, Directive, ElementRef, HostListener, NgZone, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import Stepper from 'bs-stepper';
import { QuillEditorComponent } from 'ngx-quill';
import { Amenity, Product, ProductStatus } from 'src/app/model/product';
import { User } from 'src/app/model/user';
import { AuthService } from 'src/app/service/auth.service';
import { S3Service } from 'src/app/service/s3.service';
import { Hashtag } from '../../../model/product';

@Directive()
export class MeetingControl implements AfterViewInit {
  user: User;
  quillStyle;
  quill: QuillEditorComponent;
  productForm: UntypedFormGroup;
  hashtags: Hashtag[];
  amenities: Amenity[];

  stepper: Stepper;
  @ViewChild('stepperRef', { static: false }) stepperRef?: ElementRef;

  SEOUL_LATITUDE = 37.566535;
  SEOUL_LONGITUDE = 126.9779692;
  latitude: number;
  longitude: number;
  country: string;
  sido: string;
  sigugun: string;
  dongmyun: string;
  ri: string;
  rest: string;
  zoom: number;

  previewProduct: Product;

  passDeactivate = false;
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification(event: any) {
    if (!this.passDeactivate && this.productForm.dirty) {
      event.returnValue = true;
    }
  }

  isLoad = false;
  phoneNumberForm: UntypedFormGroup;
  @ViewChild('addPhoneTpl') addPhoneTpl: any;

  constructor(
    public ngZone: NgZone,
    public s3Service: S3Service,
    public authService: AuthService,
    public bottomSheet: MatBottomSheet,
  ) {}

  ngAfterViewInit(): void {
    if (this.stepperRef?.nativeElement) {
      this.stepper = new Stepper(this.stepperRef.nativeElement, {
        linear: false,
        selectors: {
          steps: '.step',
          trigger: '.step-trigger',
          stepper: '.bs-stepper',
        },
      });
    }

    if (window.location.href.includes('meeting-add')) {
      this.authService.getCurrentUserFromServer().subscribe((user) => {
        if (!user?.phoneNumber) {
          this.phoneNumberForm = new UntypedFormGroup({
            phone: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{11}')]),
          });
          this.bottomSheet.open(this.addPhoneTpl, {
            closeOnNavigation: true,
            disableClose: true,
            panelClass: 'nnb-bottom-sheet',
          });
        }
      });
    }
  }

  quillLoad(event) {
    this.quill = event;
  }

  changeAddress(event) {
    this.productForm.controls.address.setValue(event.address);
    const { latitude, longitude, country, sido, sigugun, dongmyun, ri, rest } = event;
    this.latitude = latitude;
    this.longitude = longitude;
    this.country = country;
    this.sido = sido;
    this.sigugun = sigugun;
    this.dongmyun = dongmyun;
    this.ri = ri;
    this.rest = rest;
  }

  next() {
    const index = this.stepper['_currentIndex'];
    if (index === 7) {
      this.makePreviewProduct();
    }
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
    this.stepper.next();
  }

  prev() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
    this.stepper.previous();
  }

  makePreviewProduct() {
    if (this.productForm.value.version === 1) {
      const {
        version,
        title,
        hashtags,
        photos,
        address,
        detailAddress,
        howToCome,
        runningDays,
        runningHours,
        runningMinutes,
        reservationHours,
        price,
        discountPrice,
        point,
        recommend,
        description,
        courses,
        amenities,
        notice,
        checkList,
        includeList,
        excludeList,
        refundPolicy,
      } = this.productForm.value;
      const amenityList = this.amenities.filter((a) => amenities.find((v) => a.id == v));
      const hashtagList =
        hashtags.map((h) => {
          if (typeof h === 'number') {
            return this.hashtags.find((v) => v.id === h);
          } else if (typeof h === 'string') {
            return new Hashtag(undefined, h);
          } else {
            return h;
          }
        }) || [];
      this.previewProduct = new Product(
        0,
        title,
        price,
        discountPrice,
        recommend,
        version,
        address,
        detailAddress,
        howToCome,
        runningDays,
        runningHours,
        runningMinutes,
        reservationHours,
        this.latitude,
        this.longitude,
        undefined,
        notice,
        checkList,
        includeList,
        excludeList,
        refundPolicy,
        ProductStatus.DISABLED,
        true,
        true,
        '',
        undefined,
        description,
        point,
        undefined,
        undefined,
        undefined,
        hashtagList,
        amenityList,
        0,
        false,
        undefined,
        new Date(),
        new Date(),
        photos,
        courses,
        [],
      );
    } else {
      const {
        version,
        title,
        hashtags,
        photos,
        address,
        detailAddress,
        howToCome,
        runningDays,
        runningHours,
        runningMinutes,
        reservationHours,
        price,
        discountPrice,
        recommend,
        description,
        summaries,
        sections,
        courses,
        amenities,
        notice,
        checkList,
        includeList,
        excludeList,
        refundPolicy,
      } = this.productForm.value;
      const amenityList = this.amenities.filter((a) => amenities.find((v) => a.id == v));
      const hashtagList =
        hashtags?.map((h) => {
          if (typeof h === 'number') {
            return this.hashtags.find((v) => v.id === h);
          } else if (typeof h === 'string') {
            return new Hashtag(undefined, h);
          } else {
            return h;
          }
        }) || [];
      this.previewProduct = new Product(
        0,
        title,
        price,
        discountPrice,
        recommend,
        version,
        address,
        detailAddress,
        howToCome,
        runningDays,
        runningHours,
        runningMinutes,
        reservationHours,
        this.latitude,
        this.longitude,
        undefined,
        notice,
        checkList,
        includeList,
        excludeList,
        refundPolicy,
        ProductStatus.DISABLED,
        true,
        true,
        '',
        undefined,
        description,
        undefined,
        summaries,
        sections,
        undefined,
        hashtagList,
        amenityList,
        0,
        false,
        undefined,
        new Date(),
        new Date(),
        photos,
        courses,
        [],
      );
    }
  }

  ngOnDestroy() {
    this.stepper.reset();
    this.productForm.reset();
    (this.productForm.controls.photos as UntypedFormArray).clear();
  }
}
